module.exports = __webpack_public_path__ + "static/img/ua_block_rgb_3.3c82a4c.3c82a4c.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/ua_block_rgb_3.3c82a4c.png
// module id = edf+
// module chunks = 1